import {isValidHttpUrl} from "./helpers";

let breadcrumbs: IBreadcrumb[] = [];

export interface IBreadcrumb {
  url: string|null,
  text: string,
}

// Validate JSON. Input value can be Any type.
const validateBreadcrumb = (breadcrumbs: IBreadcrumb[]|null): IBreadcrumb[]|null => {
  if (!Array.isArray(breadcrumbs)) {
    return null
  }

  const breadcrumbsResult: IBreadcrumb[] = [];
  let hasError: boolean = false;

  breadcrumbs.forEach((breadcrumb: IBreadcrumb) => {
    // Check text value in JSON
    if (!breadcrumb.text) {
      console.error('Widgets Error: Invalid JSON for breadcrumbs. Wrong "text" value.')
      hasError = true;
    }

    // Check URL in JSON
    if (breadcrumb.url && !isValidHttpUrl(breadcrumb.url)) {
      console.error(`Widgets Error: Invalid JSON for breadcrumbs. Wrong "url" value: ${breadcrumb.url}.`)
      hasError = true;
    }

    breadcrumbsResult.push({
      url: breadcrumb.url ? breadcrumb.url : null,
      text: breadcrumb.text
    })
  })

  return hasError ? null : breadcrumbsResult;
}

export const setUpBreadcrumbs = (breadcrumbsJson: string): void => {
  try {
    const validatedBreadcrumbsArray = validateBreadcrumb(JSON.parse(breadcrumbsJson));
    breadcrumbs = validatedBreadcrumbsArray ?? [];
  } catch (err) {
    console.error('Widgets Error: Invalid JSON for breadcrumbs. Can`t parse JSON.');
    console.log(err);
    breadcrumbs = [];
  }
}

export const getBreadcrumbs = (): IBreadcrumb[] => breadcrumbs;
